import { z } from 'zod';

export const PageViewDestination = z.enum([
  'IFG_ADV',
  'ELITE_INSURANCE',
  'SVG',
  'FORTEGRA',
  'USHA_MONTAGUE',
  'USHA_KONCURAT',
  'IHEALTHQUOTES',
  'HMSOLUTIONS',
  'SELFGOOD',
  'ROCKETHEALTH',
  'MEDICARE_GENIUS',
  'SVG_ADV',
  'TZ',
  'MEDICARE_DEFAULT',
  'CALL',
  'AARP_CLICK',
  'HEALTH_CONNECT_CLICK',
  'EHEALTH_CLICK',
  'EHEALTH_MEDICARE_SUPPLEMENT',
  'EHEALTH_MEDICARE_ADVANTAGE',
  'KAISER',
  'FIRSTFAMILY',
  'QUOTES_DEFAULT',
  'TEST',
  'QUOTES_MEDICARE_ADVANTAGE',
  'QUOTES_MEDICARE_SUPPLEMENT',
  'QUOTE_DETAILS_MEDICARE_ADVANTAGE',
  'QUOTE_DETAILS_MEDICARE_SUPPLEMENT',
  'TZ_PBL',
  'TZ_PBL_WEEKEND',
  'TZ_PBL_OUT_OF_HOURS',
  'ALLIED_HEALTH',
  'MAINLINE_BENEFITS',
  'BENEFITS_BOSS',
  'GREEN_VINE_INSURANCE',
  'ASSURED_HEALTH',
  'MEDICARE_QUOTES',
]);

export type PageViewDestination = z.infer<typeof PageViewDestination>;
